import { useEffect } from "react";
import RtnEventsEmitter from "../services/realTimeNotification/rtnEventsEmitter";

export const useRtn = (rtnTypes: string | string[], handler: (...args: any[]) => void) => {
  useEffect(() => {
    RtnEventsEmitter.subscribe(rtnTypes, handler);
    return () => RtnEventsEmitter.unsubscribe(rtnTypes, handler);
  }, [rtnTypes, handler]);
};
